import { api } from './client.js';

export const fetchDiscounts = () => api.get('/discounts').then((r) => r.data.discounts);
// Returns { discounts: [...] } — one per store when created for both stores.
export const createDiscount = (body) => api.post('/discounts', body).then((r) => r.data);
export const updateDiscount = (id, body) => api.put(`/discounts/${id}`, body).then((r) => r.data);
export const setDiscountActive = (id, active) => api.post(`/discounts/${id}/active`, { active }).then((r) => r.data);
export const setDiscountArchived = (id, archived) => api.post(`/discounts/${id}/archive`, { archived }).then((r) => r.data);
export const deleteDiscount = (id) => api.delete(`/discounts/${id}`).then((r) => r.data);
export const fetchDiscountReport = (id) => api.get(`/discounts/${id}/report`).then((r) => r.data);

// Before launch (nothing saved): a client's result on an order of X, thresholds per currency, segments.
export const previewDiscount = (body) => api.post('/discounts/preview', body).then((r) => r.data);
export const fetchThresholds = (body) => api.post('/discounts/thresholds', body).then((r) => r.data.currencies);
export const fetchSegment = (body) => api.post('/discounts/segment', body).then((r) => r.data);

// A client's live + upcoming promotions (client page card, staff + reps).
export const fetchCompanyPromotions = (companyId) => api.get(`/me/clients/${companyId}/promotions`).then((r) => r.data);
